export default {
  id: null,
  empresaID: null,
  nome: null,
  descricao: null,
  status: null,
  dateUpdate: null,
  contaIDAcao: null
}



// WEBPACK FOOTER //
// ./src/shared/models/access/groupmodel.js